import { render } from "./ParticipantPermissionsEditor.vue?vue&type=template&id=7d3b1710"
import script from "./ParticipantPermissionsEditor.vue?vue&type=script&lang=js"
export * from "./ParticipantPermissionsEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__